import { all } from 'redux-saga/effects';
import getDataControl from './getDataControl';

export const dataControlSagas = function* root() {
  yield all([getDataControl()]);
};
